export const SET_ASSITERS_PLAYERS = 'SET_ASSITERS_PLAYERS';